module.exports = __webpack_public_path__ + "523c34c7794828e8b6d6f82221fccd02.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/war_has_a_price-1050.jpg
// module id = 614
// module chunks = 0